"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalSearchListResponseSchema = void 0;
var zod_1 = require("zod");
var product_unit_1 = require("../product-unit");
var LocalSearchListItemSchema = zod_1.z.discriminatedUnion('type', [
    product_unit_1.ProductUnitSchema,
    product_unit_1.RelatedKeywordSchema,
    product_unit_1.OmBannerSchema,
    product_unit_1.SectionDividerSchema,
    product_unit_1.SectionGroupHeaderSchema,
]);
exports.LocalSearchListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(LocalSearchListItemSchema),
    paging: zod_1.z.object({ current: zod_1.z.number(), isLast: zod_1.z.boolean(), total: zod_1.z.number() }).nullish(),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
    noProductResult: zod_1.z.boolean().nullish(),
    spellCorrection: zod_1.z.string().nullish(),
});
